import React, { createContext, useContext, useState } from 'react';

const ProfileSidebarContext = createContext();

const getApiUrl = () => {
  const RAILWAY_API = import.meta.env.VITE_API_URL || 'https://registration-app-production.up.railway.app';
  const LOCALHOST_API = 'http://localhost:3000';
  
  const isLocalhost = 
    window.location.hostname === 'localhost' ||
    window.location.hostname === '127.0.0.1';
  
  return isLocalhost ? LOCALHOST_API : RAILWAY_API;
};

export const useProfileSidebar = () => {
  const context = useContext(ProfileSidebarContext);
  if (!context) {
    throw new Error('useProfileSidebar must be used within ProfileSidebarProvider');
  }
  return context;
};

export const ProfileSidebarProvider = ({ children }) => {
  const [profileData, setProfileData] = useState(null);
  const [isOpen, setIsOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  
  const openProfile = async (profileOrId) => {
    setIsOpen(true);
    
    // lastActiveAt が含まれていない場合は必ずAPIから取得する
    const hasLastActiveAt = profileOrId?.lastActiveAt !== undefined;
    const needsFetch = 
      typeof profileOrId === 'number' || 
      (profileOrId?.id && !profileOrId.display_name && !profileOrId.displayName) ||
      !hasLastActiveAt;
    
    if (needsFetch) {
      setLoading(true);
      try {
        const actorId = typeof profileOrId === 'number' 
          ? profileOrId 
          : (profileOrId.actorId || profileOrId.actor_id || profileOrId.id);
        const API_URL = getApiUrl();
        const response = await fetch(`${API_URL}/api/actor-profile/${actorId}`, {
          headers: {
            'Authorization': `Bearer ${localStorage.getItem('token')}`,
            'Content-Type': 'application/json',
          },
        });
        
        if (response.ok) {
          const data = await response.json();
          setProfileData(data);
        } else {
          setProfileData(profileOrId);
        }
      } catch (error) {
        setProfileData(profileOrId);
      } finally {
        setLoading(false);
      }
    } else {
      setProfileData(profileOrId);
    }
  };
  
  const closeProfile = () => {
    setIsOpen(false);
    setTimeout(() => {
      setProfileData(null);
      setLoading(false);
    }, 300);
  };
  
  const value = {
    openProfile,
    closeProfile,
    isOpen,
    profileData,
    loading,
  };
  
  return (
    <ProfileSidebarContext.Provider value={value}>
      {children}
    </ProfileSidebarContext.Provider>
  );
};
